export const ORDER_TYPES = {
    DELIVERY: 'delivery', // доставка
    SELF: 'self', // самовывоз
    SUBDELIVERY: 'subdelivery', // довоз
    PREORDER: 'preorder', // предзаказ
    STAFF_OWN: 'staff_own', // стафф-заказ для питания сотрудников
    STAFF_OTHER: 'staff_other', // другие стафф-заказы
}

export const STAFF_TYPE_IDS = [ORDER_TYPES.STAFF_OWN, ORDER_TYPES.STAFF_OTHER]

export const STAFF_ORDER_TYPE = 'staff'

export const ORDER_TYPE_NAMES = {
    [ORDER_TYPES.DELIVERY]: 'Доставка',
    [ORDER_TYPES.SELF]: 'Самовывоз',
    [ORDER_TYPES.SUBDELIVERY]: 'Довоз',
    [ORDER_TYPES.PREORDER]: 'Предзаказ',
    [STAFF_ORDER_TYPE]: 'Стафф-заказ',
}

export const ORDER_TYPE_OPTIONS = [
    ORDER_TYPES.DELIVERY,
    ORDER_TYPES.SELF,
    ORDER_TYPES.SUBDELIVERY,
    ORDER_TYPES.PREORDER,
    STAFF_ORDER_TYPE,
].map(type => ({
    name: ORDER_TYPE_NAMES[type],
    value: type,
}))

export const INTERVALS_AVAILABLE_ORDER_TYPES = [
    ORDER_TYPES.SELF,
    ORDER_TYPES.DELIVERY,
    ORDER_TYPES.PREORDER,
]

export const INCLUDED_STAFF_OTHER_RK_SIFR_IDS = [
    1116213, 1154079, 1154081, 1119848,
]
export const EXCLUDED_STAFF_OTHER_RK_SIFR_IDS = [
    1116213, 1154079, 1154081, 1154077, 1119848,
]
